{
  "schema_version": "1.0",
  "run_id": "run_20260712_130000_ist",
  "edition_key": "2026-07-12-1300-Asia-Kolkata",
  "created_at": "2026-07-12T07:33:00Z",
  "claims": [
    {
      "claim_id": "C001",
      "verdict": "PASS",
      "risk": "low",
      "source_ids": ["the-hindu-national"],
      "source_urls": ["https://www.thehindu.com/news/national/green-hydrogen-mission-approved/article1.ece"],
      "evidence": [
        {
          "source_id": "the-hindu-national",
          "excerpt": "The Union Cabinet on Saturday approved the National Green Hydrogen Mission with an outlay of ₹12,000 crore.",
          "snapshot_path": "source_snapshots/story-001.json"
        }
      ],
      "mismatches": [],
      "reason": "The cabinet approval, outlay amount, and mission name match the source exactly.",
      "suggested_text_hi": null
    },
    {
      "claim_id": "C002",
      "verdict": "PASS",
      "risk": "low",
      "source_ids": ["indian-express-india"],
      "source_urls": ["https://indianexpress.com/article/business/rbi-repo-rate-hold-2026/"],
      "evidence": [
        {
          "source_id": "indian-express-india",
          "excerpt": "The Monetary Policy Committee voted 5-1 to keep the repo rate unchanged at 5.5%.",
          "snapshot_path": "source_snapshots/story-002.json"
        }
      ],
      "mismatches": [],
      "reason": "The repo rate value and the RBI attribution match the source.",
      "suggested_text_hi": null
    },
    {
      "claim_id": "C003",
      "verdict": "PASS",
      "risk": "low",
      "source_ids": ["ndtv-latest"],
      "source_urls": ["https://www.ndtv.com/india-news/monsoon-reaches-delhi-ahead-of-schedule-2026/"],
      "evidence": [
        {
          "source_id": "ndtv-latest",
          "excerpt": "The southwest monsoon arrived in Delhi on July 10, two days before the normal onset date of July 12, the IMD said.",
          "snapshot_path": "source_snapshots/story-003.json"
        }
      ],
      "mismatches": [],
      "reason": "The monsoon arrival, location, and early onset timing match the source.",
      "suggested_text_hi": null
    }
  ],
  "summary": {
    "passed": 3,
    "rewrite": 0,
    "blocked": 0,
    "gate_recommendation": "PASS"
  }
}
